import { PropsWithChildren } from 'react';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 1.2rem;
  color: ${({ theme }) => theme.colors.primary};
`;

export function Loader({ children }: PropsWithChildren) {
  return <LoaderContainer>{children || 'Carregando...'}</LoaderContainer>;
}
